import styled from 'styled-components';

export const Main = styled.main`
    background-color: #fff;
    width: 100vw;
    height: 100vh;
    @media screen and (min-width: 600px) {
        width: 400px;
        height: 700px;
        min-height: 500px;
        background-color: #fff;
        border-radius: 15px;
        box-shadow: rgba(0, 0, 0, 0.2) 0 0 20px;
        border: 1px solid #cecece;
    }
`;

/* export const ListContainer = styled.div`
    padding: 0px 18px;
`; */

export const ListBody = styled.div``;
